export const statusToneMap = {
  success: { label: 'ناجح', className: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  warning: { label: 'تحذير', className: 'bg-amber-50 text-amber-700 border-amber-200' },
  error: { label: 'خطأ', className: 'bg-red-50 text-red-700 border-red-200' },
  info: { label: 'معلومات', className: 'bg-blue-50 text-blue-700 border-blue-200' },
  pending: { label: 'قيد الانتظار', className: 'bg-violet-50 text-violet-700 border-violet-200' },
  draft: { label: 'مسودة', className: 'bg-stone-50 text-stone-700 border-stone-200' },
  approved: { label: 'معتمد', className: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  posted: { label: 'مرحل', className: 'bg-blue-50 text-blue-700 border-blue-200' },
  processed: { label: 'معالج', className: 'bg-teal-50 text-teal-700 border-teal-200' },
  cancelled: { label: 'ملغي', className: 'bg-red-50 text-red-700 border-red-200' },
  overdue: { label: 'متأخر', className: 'bg-orange-50 text-orange-700 border-orange-200' },
  paid: { label: 'مدفوع', className: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  partiallyPaid: { label: 'مدفوع جزئياً', className: 'bg-amber-50 text-amber-700 border-amber-200' },
  archived: { label: 'مؤرشف', className: 'bg-stone-100 text-stone-700 border-stone-200' },
  disabled: { label: 'معطل', className: 'bg-stone-100 text-stone-500 border-stone-200' },
};
export const normalizeStatus = (status = '') => String(status).trim().toLowerCase().replace(/[\s_-]+(.)/g, (_, c) => c.toUpperCase());
export const getStatusTone = (status) => statusToneMap[normalizeStatus(status)] || statusToneMap.info;
